import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Aviso al salir de un formulario con cambios sin guardar.
 *
 * Cierra con `true` para descartar y salir, con `false` (o al hacer clic fuera)
 * para quedarse. El botón que se queda es el primario: salir es la acción que
 * pierde datos, así que no debe ser la que se aprieta por inercia.
 */
@Component({
  selector: 'app-confirmar-salida',
  imports: [MatDialogModule, TranslateModule],
  templateUrl: './confirmar-salida.html',
  styleUrl: './confirmar-salida.scss',
})
export class ConfirmarSalida {
  private dialogRef = inject(MatDialogRef<ConfirmarSalida, boolean>);

  protected quedarse(): void {
    this.dialogRef.close(false);
  }

  protected salir(): void {
    this.dialogRef.close(true);
  }
}
